import React from 'react';

function ButtonGroup(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: "tw-flex".concat(className ? " ".concat(className) : "") }, children));
}

export { ButtonGroup, ButtonGroup as default };
//# sourceMappingURL=ButtonGroup.esm.js.map
